module.exports = __webpack_public_path__ + "static/media/img19.82700c3e.jpg";